import { IGigPayoutsUpload } from "store/partner-services/partnerServicesSlice";

const STORAGE_KEY = "processingEarningPayouts";

export const persistProcessingEarningPayouts = (data: IGigPayoutsUpload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getPersistedProcessingEarningPayouts = (): IGigPayoutsUpload => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

export const removePersistedProcessingEarningPayouts = () => {
  localStorage.removeItem(STORAGE_KEY);
};
